import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { blankImage } from '../utils';
import { ImageWrapper } from './ImageWrapper';

export class Image extends React.PureComponent {

  render() {

    const {
      className,
      src,
      sizes,
      breakpoints,
      applyCloudinary,
      // applyTransform,
      alt: altValue,
      displayAlt,
      style,
      innerStyle,
      position,
      loading,
      fadeIn,
      align,
      size,
    } = this.props;

    const alt = altValue === 'undefined' ? false : altValue;

    const imageIsNetlifyCMSObject = (typeof src === 'object' && src?.url);

    const isEditorBlob = (imageIsNetlifyCMSObject && src.url.slice(0, 5) === 'blob:');

    const prependCloudinary = 'https://res.cloudinary.com/sollerodgolf/image/upload/f_auto,q_auto,c_fill,g_faces:center';

    const match = /v(\d{10})\//.exec(src);

    let image = typeof src === 'string' && applyCloudinary && match?.index ? src.substr(match.index ?? 0) : src;

    let srcSet = [];

    if (imageIsNetlifyCMSObject && !isEditorBlob) {
      image = src.url;
    }

    let isCloudinary = false;

    const hasBreakpoints = breakpoints.length > 0;
    const isSVG = typeof image === 'string' && image.slice(-4) === '.svg';
    const isBase64 = typeof image === 'string' && image.slice(0, 10) === 'data:image';

    if (image?.childImageSharp) image = image.childImageSharp;
    else if (image?.cloudinary) image = image.cloudinary;
    else if (hasBreakpoints && applyCloudinary) {
      srcSet = breakpoints.map(({ width, height, resolution }) => `${prependCloudinary},w_${width}${height ? `,h_${height}` : ''}/${image} ${resolution || `${width}w`}`);
      image = `${prependCloudinary},w_${breakpoints[0].width}${breakpoints[0].height ? `,h_${breakpoints[0].height}` : ''}/${image}`;
      isCloudinary = true;
    } else if (!hasBreakpoints && applyCloudinary && !isBase64 && typeof src === 'string') {
      image = `${prependCloudinary}/${image}`;
      isCloudinary = true;
    }

    if (isEditorBlob || src.path === 'empty.svg') {
      return null;
    }
    if (src?.url && isEditorBlob) {
      return <img src={src.url} alt={alt} style={innerStyle} data-align={align} data-size={size} />;
    }
    if (src?.publicURL) {
      return <img src={src.publicURL} alt={alt} style={innerStyle} data-align={align} data-size={size} />;
    }
    if ((isCloudinary && isSVG) || isBase64) {
      return (
        <img src={image} alt={alt} style={innerStyle} />
      );
    }
    if (isCloudinary && !isSVG) {
      return (
        <ImageWrapper className={className} style={{ paddingBottom: 0, height: 'auto', ...style }} align={align} size={size}>
          <img
            src={image}
            srcSet={srcSet}
            alt={alt}
            sizes={sizes}
            style={{ position: 'static', ...innerStyle }}
          />
          { (alt && displayAlt) && <span>{alt}</span>}
        </ImageWrapper>
      );
    }
    if (image?.fluid) {
      return (
        <Img
          fluid={{ ...image.fluid, sizes }}
          alt={alt}
          style={style}
          loading={loading}
          fadeIn={fadeIn}
          durationFadeIn={1000}
          imgStyle={{ objectPosition: position, ...innerStyle }}
        />
      );
    }
    if (image?.resize) {
      return (
        <ImageWrapper style={style} align={align} size={size} aspectRatio={image.resize.aspectRatio} position={position}>
          <img
            src={image.resize.src}
            alt={alt}
            style={innerStyle}
          />
        </ImageWrapper>
      );
    }
    if (image?.fixed) {
      return (
        <Img
          fixed={image.fixed}
          alt={alt}
          style={style}
          loading={loading}
          fadeIn={fadeIn}
          durationFadeIn={1000}
          imgStyle={{ objectPosition: position }}
        />
      );
    }
    if (typeof image === 'string' && isSVG) {
      // Editor
      return (
        <div>
          <img src={image} alt={alt} />
        </div>
      );
    }
    return <img src={blankImage} alt="Billedet blev ikke indlæst" data-align={align} data-size={size} />;
  }
}

Image.propTypes = {
  src: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]),
  breakpoints: PropTypes.arrayOf(PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number,
    resolution: PropTypes.string,
  })),
  alt: PropTypes.string,
  displayAlt: PropTypes.bool,
  style: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]),
  innerStyle: PropTypes.oneOfType([ PropTypes.object, PropTypes.string ]),
  position: PropTypes.string,
  loading: PropTypes.string,
  fadeIn: PropTypes.bool,
  align: PropTypes.string,
  size: PropTypes.string,
  sizes: PropTypes.string,
  // applyTransform: PropTypes.string,
  applyCloudinary: PropTypes.bool,
  className: PropTypes.string,
};

Image.defaultProps = {
  src: {},
  sizes: '',
  breakpoints: [],
  alt: '',
  displayAlt: true,
  style: {},
  innerStyle: {},
  position: 'center center',
  loading: 'lazy',
  fadeIn: true,
  align: 'none',
  size: 'large',
  // applyTransform: '',
  applyCloudinary: true,
  className: '',
};
